import { ITrackingObject } from 'i2g-ng-tracking';

export enum TooltipPointerDirectionEnum {
  up = 'up',
  down = 'down',
  left = 'left',
  right = 'right',
}

export enum TooltipType {
  default = 'default',
  onboarding = 'onboarding',
}

export interface ITooltip {
  title: string;
  description: string;
  /**
   * The selector you specify here will be used
   * as the query selector, i.e.
   *
   * document.querySelector(selectors)
   */
  selectors: string;
  pointerDirection?: TooltipPointerDirectionEnum;
  pointerPosition?: number; // 0 = left or top; 1 = right or bottom
  autoPointerDirection?: boolean;
  autoPointerPosition?: boolean;
  pointerDistance?: number;
  scrollIntoView?: boolean;
  hidePointer?: boolean;
}

export interface ITooltipSequence {
  trackingObject?: ITrackingObject;
  trackingScreenName?: string;
  isDismissible?: boolean;
  showProgress?: boolean;
  tooltipType?: TooltipType;
  tooltips: ITooltip[];
}
